import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserModeService } from '../../customs/user-mode/user-mode.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const userModeService = inject(UserModeService);

  console.log(route);

  // 👇 Retrieve allowed modes from route data
  const allowedModes = route.data['allowedModes'] as
    | ('customer' | 'provider')[]
    | undefined;
  const currentMode = userModeService.currentMode;

  console.log('Allowed modes:', allowedModes);
  console.log('Current mode:', currentMode);

  if (!currentMode) {
    router.navigate(['/login']);
    return false;
  }

  if (allowedModes && !allowedModes.includes(currentMode)) {
    router.navigate(['/dashboard'], { queryParams: { accessDenied: true } });
    return false;
  }

  return true;
};
